import React, { useState } from 'react'
import about from '../images/about_org.jpg'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Careers() {

  const [expanded, setExpanded] = useState('panel1'); // Manage accordion state
  const { token, isEmailVerified, isContactVerified } = useSelector((state) => state.qps);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [selectedOffice, setSelectedOffice] = useState('Indian');
  useDocTitle("Careers");

  return (
   <div className="bg-[#F9F8F8]">
   <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        <div className="relative z-20 h-full flex items-center justify-center text-white">
  <h2  className={`${commonStyles.pageTitle} text-white`}>
    Careers
  </h2>
</div>

      </div>
<CommonContainer>
      <div className='mt-12'>
        {/* <p className="text-base font-bold text-blue-500 mb-6 text-center">Careers</p> */}
      </div>


      {/* <div className='mt-16'>
        <p className="text-2xl font-bold text-blue-500 mb-6 text-center"></p>
      </div> */}

      <div>
        <div className="text-center mb-6 ">
          <Button
  variant={selectedOffice === 'Indian' ? 'contained' : 'outlined'}
  color="primary"
  className="mx-3 text-base"
  onClick={() => setSelectedOffice('Indian')}
  sx={{
    ...(selectedOffice === "Indian" && {
      backgroundColor: "#153E75",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#1E88E5",
      },
    }),
    ...(selectedOffice !== "Indian" && {
      borderColor: "#153E75",
      color: "#153E75",
      "&:hover": {
        borderColor: "#1E88E5",
        color: "#1E88E5",
      },
    }),
  }}
>
  <span className="text-base">India</span>
</Button>
          &nbsp;
          <Button
  variant={selectedOffice === 'US' ? 'contained' : 'outlined'}
  color="primary"
  className="mx-3 text-base"
  onClick={() => setSelectedOffice('US')}
  sx={{
    ...(selectedOffice === "US" && {
      backgroundColor: "#153E75",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#1E88E5",
      },
    }),
    ...(selectedOffice !== "US" && {
      borderColor: "#153E75",
      color: "#153E75",
      "&:hover": {
        borderColor: "#1E88E5",
        color: "#1E88E5",
      },
    }),
  }}
>
  <span className="text-base">USA</span>
</Button>
        </div>

      <div className="mt-10">

  <div>
            {/* First Accordion */}
            {selectedOffice === 'Indian' && (
              <>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                      <Typography sx={{ fontSize: '16px', color: 'green' }}>
                        1. Digital Marketing - Fresher - 1 position
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      {isContactVerified && isEmailVerified ? (
                        <>
                          <div>
                            <p className="ml-5 text-2xl">Job Description</p>

                            {/* Grid layout with two columns */}
                            <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-28">
                              {/* Responsibilities Column */}
                              <div>
                                <p className="text-sm font-bold ml-5">Responsibilities</p>
                                <div className="my-5">
                                  <ul className="space-y-8 ml-10">
                                    <li className="text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Design, implement, and maintain Java-based applications.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Contribute to all phases of the development lifecycle.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Write well-designed, efficient, and testable code.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Analyze and troubleshoot issues in existing applications.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Participate in code reviews to ensure adherence to coding standards and best practices.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Integrate applications with databases, third-party services, and APIs.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Optimize application performance, scalability, and reliability.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Create technical documentation for reference and reporting.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Collaborate with cross-functional teams to define, design, and ship new features.
                                    </li>

                                  </ul>
                                </div>
                              </div>

                              {/* Requirements Column */}
                              <div>
                                <p className="text-sm font-bold ml-5">Requirements</p>
                                <div className="my-5">
                                  <ul className="space-y-8 ml-10">
                                    <li className="text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Strong foundation in Core Java concepts (OOP, Collections, Multithreading, etc.).
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Knowledge of frameworks like Spring Boot, Hibernate, or JavaFX is a plus.
                                    </li>
                                    <li className="flex items-center text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Familiarity with web development technologies like HTML, CSS, and JavaScript.
                                    </li>
                                    <li className="flex items-center text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Knowledge of version control tools such as Git.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Familiarity with build tools (e.g., Maven, Gradle) and CI/CD pipelines.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Good understanding of database systems (SQL/NoSQL).
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Excellent communication and collaboration skills.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Attention to detail and focus on writing clean, maintainable code.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Bachelor’s or Master’s degree in Computer Science, Engineering, or a related field.
                                    </li>
                                    <li className="flex text-sm">
                                      <span className="text-green-500 mr-2">✔</span>
                                      Freshers with 0-6 months of experience are welcome to apply.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                          
                          </div>
                        </>) :
                        (
                          <>
                            <div className="relative">
                           
                              <div className="blur-md">
                                <p className="ml-5 text-sm">Job Description</p>

                                {/* Grid layout with two columns */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">
                                  {/* Responsibilities Column */}
                                  <div>
                                    <p className="text-sm font-bold ml-5">Responsibilities</p>
                                    <div className="my-5">
                                      <ul className="space-y-8 ml-10">
                                        <li className="text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Research and build a customer list for email marketing.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Marketing our product via online and email.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Setup a digital marketing program - Facebook, Twitter, and Google. Utilize the various online tools to promote the company’s online image and brand.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Assess various online campaigns and improve product visibility.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Training on job tasks.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  {/* Requirements Column */}
                                  <div>
                                    <p className="text-sm font-bold ml-5">Requirements</p>
                                    <div className="my-5">
                                      <ul className="space-y-8 ml-10">
                                        <li className="text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Ability to document / good vocabulary.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Good communication skills.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Attention to detail.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Strong organizational skills.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Any Bachelors or Masters Degree - Diploma.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Freshers from 0-6 months experience.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Timings are from 11 AM to 8 PM – US first shift for the first 3 months.
                                        </li>
                                        <li className="flex text-sm">
                                          <span className="text-green-500 mr-2">✔</span>
                                          Work from home (optional).
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-40">
                                <div className="text-center">
                                  <p className="text-xl font-semibold text-gray-800 mb-3">Login to continue</p>
                                  <a href="/login">
  <button className="px-6 py-2 rounded-lg bg-[#153E75] hover:bg-[#1E88E5] text-white font-semibold transition-all duration-300">
    Login
  </button>
</a>
                                </div>
                              </div>

                            </div>
                          </>
                        )}


                      <div className="flex justify-center items-center mt-8">
                        {isContactVerified && isEmailVerified && (
                          <Button variant="contained" href="/career-form">
                            <span className='text-base'>Apply here</span>
                          </Button>
                        )}
                      </div>
                    </Typography>


                  </AccordionDetails>
                </Accordion>
                <br />
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                      <Typography sx={{ fontSize: '16px', color: 'green' }}>
                        2. JAVA Developer - Fresher - 1 position
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                    {isContactVerified && isEmailVerified ? ( 
                      <>
                       <div>
                        <p className="ml-5 text-2xl">Job Description</p>

                        {/* Grid layout with two columns */}
                        <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-28">
                          {/* Responsibilities Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Responsibilities</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Design, implement, and maintain Java-based applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Contribute to all phases of the development lifecycle.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Write well-designed, efficient, and testable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Analyze and troubleshoot issues in existing applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Participate in code reviews to ensure adherence to coding standards and best practices.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Integrate applications with databases, third-party services, and APIs.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Optimize application performance, scalability, and reliability.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Create technical documentation for reference and reporting.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Collaborate with cross-functional teams to define, design, and ship new features.
                                </li>

                              </ul>
                            </div>
                          </div>

                          {/* Requirements Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Requirements</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Strong foundation in Core Java concepts (OOP, Collections, Multithreading, etc.).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of frameworks like Spring Boot, Hibernate, or JavaFX is a plus.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with web development technologies like HTML, CSS, and JavaScript.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of version control tools such as Git.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with build tools (e.g., Maven, Gradle) and CI/CD pipelines.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Good understanding of database systems (SQL/NoSQL).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Excellent communication and collaboration skills.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Attention to detail and focus on writing clean, maintainable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Bachelor’s or Master’s degree in Computer Science, Engineering, or a related field.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Freshers with 0-6 months of experience are welcome to apply.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                    
                      </div>
                      </>
                    ) :
                    (<>
                     <div className="relative">
                           
                           <div className="blur-md">
                           <div>
                        <p className="ml-5 text-2xl">Job Description</p>

                        {/* Grid layout with two columns */}
                        <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-28">
                          {/* Responsibilities Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Responsibilities</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Design, implement, and maintain Java-based applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Contribute to all phases of the development lifecycle.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Write well-designed, efficient, and testable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Analyze and troubleshoot issues in existing applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Participate in code reviews to ensure adherence to coding standards and best practices.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Integrate applications with databases, third-party services, and APIs.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Optimize application performance, scalability, and reliability.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Create technical documentation for reference and reporting.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Collaborate with cross-functional teams to define, design, and ship new features.
                                </li>

                              </ul>
                            </div>
                          </div>

                          {/* Requirements Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Requirements</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Strong foundation in Core Java concepts (OOP, Collections, Multithreading, etc.).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of frameworks like Spring Boot, Hibernate, or JavaFX is a plus.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with web development technologies like HTML, CSS, and JavaScript.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of version control tools such as Git.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with build tools (e.g., Maven, Gradle) and CI/CD pipelines.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Good understanding of database systems (SQL/NoSQL).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Excellent communication and collaboration skills.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Attention to detail and focus on writing clean, maintainable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Bachelor’s or Master’s degree in Computer Science, Engineering, or a related field.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Freshers with 0-6 months of experience are welcome to apply.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        {/* Apply Button */}
                      
                      </div>
                     
                            </div>
                            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-40">
                                <div className="text-center">
                                  <p className="text-xl font-semibold text-gray-800 mb-3">Login to continue</p>
                                  <a href="/login">
  <button className="px-6 py-2 rounded-lg bg-[#153E75] hover:bg-[#1E88E5] text-white font-semibold transition-all duration-300">
    Login
  </button>
</a>
                                </div>
                              </div>
                            </div>
                    </>)}
                      
                    <div className="flex justify-center items-center mt-8">
                          {isContactVerified && isEmailVerified && (
                            <Button variant="contained" href="/career-form">
                              <span className='text-base'>Apply here</span>
                            </Button>
                          ) }
                        </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

              </>



            )}
            {/* Second Accordion */}

            <br />
            {selectedOffice === 'US' && (
              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box sx={{ width: '100%', textAlign: 'center' }}>
                    <Typography sx={{ fontSize: '16px', color: 'green' }}>
                      1. JAVA Developer - Fresher - 1 position
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    {isContactVerified && isEmailVerified ? ( 
                      <>
                       <div>
                        <p className="ml-5 text-2xl">Job Description</p>

                        {/* Grid layout with two columns */}
                        <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-28">
                          {/* Responsibilities Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Responsibilities</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Design, implement, and maintain Java-based applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Contribute to all phases of the development lifecycle.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Write well-designed, efficient, and testable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Analyze and troubleshoot issues in existing applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Participate in code reviews to ensure adherence to coding standards and best practices.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Integrate applications with databases, third-party services, and APIs.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Optimize application performance, scalability, and reliability.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Create technical documentation for reference and reporting.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Collaborate with cross-functional teams to define, design, and ship new features.
                                </li>

                              </ul>
                            </div>
                          </div>

                          {/* Requirements Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Requirements</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Strong foundation in Core Java concepts (OOP, Collections, Multithreading, etc.).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of frameworks like Spring Boot, Hibernate, or JavaFX is a plus.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with web development technologies like HTML, CSS, and JavaScript.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of version control tools such as Git.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with build tools (e.g., Maven, Gradle) and CI/CD pipelines.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Good understanding of database systems (SQL/NoSQL).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Excellent communication and collaboration skills.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Attention to detail and focus on writing clean, maintainable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Bachelor’s or Master’s degree in Computer Science, Engineering, or a related field.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Freshers with 0-6 months of experience are welcome to apply.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                    
                      </div>
                      </>
                    ) :
                    (<>
                     <div className="relative">
                           
                           <div className="blur-md">
                           <div>
                        <p className="ml-5 text-2xl">Job Description</p>

                        {/* Grid layout with two columns */}
                        <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-28">
                          {/* Responsibilities Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Responsibilities</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Design, implement, and maintain Java-based applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Contribute to all phases of the development lifecycle.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Write well-designed, efficient, and testable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Analyze and troubleshoot issues in existing applications.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Participate in code reviews to ensure adherence to coding standards and best practices.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Integrate applications with databases, third-party services, and APIs.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Optimize application performance, scalability, and reliability.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Create technical documentation for reference and reporting.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Collaborate with cross-functional teams to define, design, and ship new features.
                                </li>

                              </ul>
                            </div>
                          </div>

                          {/* Requirements Column */}
                          <div>
                            <p className="text-sm font-bold ml-5">Requirements</p>
                            <div className="my-5">
                              <ul className="space-y-8 ml-10">
                                <li className="text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Strong foundation in Core Java concepts (OOP, Collections, Multithreading, etc.).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of frameworks like Spring Boot, Hibernate, or JavaFX is a plus.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with web development technologies like HTML, CSS, and JavaScript.
                                </li>
                                <li className="flex items-center text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Knowledge of version control tools such as Git.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Familiarity with build tools (e.g., Maven, Gradle) and CI/CD pipelines.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Good understanding of database systems (SQL/NoSQL).
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Excellent communication and collaboration skills.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Attention to detail and focus on writing clean, maintainable code.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Bachelor’s or Master’s degree in Computer Science, Engineering, or a related field.
                                </li>
                                <li className="flex text-sm">
                                  <span className="text-green-500 mr-2">✔</span>
                                  Freshers with 0-6 months of experience are welcome to apply.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        {/* Apply Button */}
                      
                      </div>
                     
                            </div>
                            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-40">
                                <div className="text-center">
                                  <p className="text-xl font-semibold text-gray-800 mb-3">Login to continue</p>
                                  <a href="/login">
  <button className="px-6 py-2 rounded-lg bg-[#153E75] hover:bg-[#1E88E5] text-white font-semibold transition-all duration-300">
    Login
  </button>
</a>
                                </div>
                              </div>
                            </div>
                    </>)}
                      
                    <div className="flex justify-center items-center mt-8">
                          {isContactVerified && isEmailVerified && (
                            <Button variant="contained" href="/career-form">
                              <span className='text-base'>Apply here</span>
                            </Button>
                          ) }
                        </div>
                    </Typography>
                  </AccordionDetails>
              </Accordion>
            )}

          </div>

        </div>
      </div>
</CommonContainer>
      </div>
  )
}

export default Careers
